<template>
    <AppLayout
        ref="layout"
        page="/dashboard"
        :pageTitle="`${eventRegister.name}`"
        backLink="/dashboard/reports/event-history"
        :selectedPeople="selectedPeople"
        :hasFab="!!selectedPeople.length"
        :fabLoading="loading"
        @fabAction="selectedPeople.length ? emailUsers() : null"
    >
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        :staticDate="eventRegister.date"
                        :subtitle="`${eventRegister.time} | ${eventRegister.location} | ${eventRegister.teacher?.name}`"
                        filter
                        :dateSelection="false"
                        @search="search = $event"
                    />
                    <v-data-table
                        ref="table"
                        :headers="headers"
                        :items="registered"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        show-select
                        :search="search"
                        v-model="selectedPeople"
                        item-key="hash_id"
                        @click:row="[$log($event.id)]"
                    >
                        <template v-slot:[`item.info.name`]="{ item }">
                            <v-list-item
                                class="soli-grey px-0"
                                style="width: min-content"
                            >
                                <v-list-item-avatar>
                                    <v-img :src="item.info.profile_photo_url" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <Link
                                        v-if="item.info.id"
                                        :href="`/profile/${item.info.id}/account`"
                                    >
                                        <v-list-item-title>
                                            {{ item.info.name }}
                                        </v-list-item-title>
                                    </Link>
                                    <v-list-item-subtitle>
                                        {{ item.info.email }}
                                        <Clipboard
                                            :text="item.info.email"
                                            label="Copy Email"
                                            x-small
                                        />
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template v-slot:[`item.child.name`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ item.child?.name }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                                small
                                :color="
                                    item.status == 'Unpaid'
                                        ? 'soli-status-red'
                                        : 'soli-status-green'
                                "
                                class="white--text font-bold"
                                >{{ item.status }}</v-chip
                            >
                        </template>

                        <template v-slot:[`item.contract_url`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-btn
                                    :href="
                                        item.contract_url
                                            ? route(
                                                  'contract.view',
                                                  item.hash_id
                                              )
                                            : route('users.show', item.info.id)
                                    "
                                    rounded
                                    target="_blank"
                                    small
                                    outlined
                                    color="accent"
                                >
                                    <v-icon
                                        :class="[
                                            item.contract_url
                                                ? 'primary--text'
                                                : 'error--text',
                                        ]"
                                        small
                                        class="pr-1"
                                        >description</v-icon
                                    >
                                    {{ item.contract_url ? "View" : "Sign" }}
                                </v-btn>
                            </div>
                        </template>

                        <template v-slot:[`item.created_at`]="{ item }">
                            <div>{{ item.created_at }}</div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
        <ComposeEmail
            v-if="composeEmail"
            :emails="selectedEmails"
            signature
            sendAsStudio
            tinyMCE
            :user="$page.props.auth.user"
            :errors="errors"
            @success="emailSuccess()"
            @reset="closeModal(() => (composeEmail = false))"
        />
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import DateRange from "../../Components/Reports/DateRange.vue";
import Stats from "../../Components/Reports/Stats.vue";
import Clipboard from "../../Components/Clipboard.vue";
import ComposeEmail from "../../Components/Users/ComposeEmail.vue";

export default {
    props: {
        errors: {},
        eventRegister: {
            type: Object,
            default: () => {},
        },
        registered: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        DateRange,
        Stats,
        Clipboard,
        ComposeEmail,
    },
    data() {
        return {
            search: "",
            showMessage: false,
            expanded: [],
            selectedPeople: [],
            selectedEmails: [],
            composeEmail: false,
            loading: false,
            headers: [
                {
                    text: "Client",
                    align: "start",
                    sortable: true,
                    value: "info.name",
                },
                {
                    text: "Child",
                    align: "start",
                    sortable: true,
                    value: "child.name",
                },
                {
                    text: "Status",
                    align: "start",
                    sortable: true,
                    value: "status",
                },
                {
                    text: "Contract",
                    align: "start",
                    sortable: true,
                    value: "contract_url",
                },
                {
                    text: "Date Registered",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
            ],
            showLeadDetails: null,
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "Attending",
                    data: this.eventRegister.attending,
                    color: "accent",
                    icon: "groups",
                },
            ];
        },
    },
    methods: {
        emailUsers() {
            if (!this.selectedPeople.length) return;
            this.loading = true;
            axios
                .get("/api/users/email", {
                    params: {
                        selectedPeople: [
                            ...new Set(
                                this.selectedPeople.map((e) => e.info.id)
                            ),
                        ],
                        getStudents: 1,
                    },
                })
                .then((resp) => {
                    this.selectedEmails = resp.data;
                    this.composeEmail = true;
                    this.loading = false;
                });
        },
        emailSuccess() {
            this.$refs.layout.showMessage = true;
            this.closeModal(() => (this.composeEmail = false));
        },
    },
    watch: {
        selectedPeople(val) {
            this.$emit("selectedPeople", val);
        },
    },
};
</script>
